import { render, staticRenderFns } from "./VaccineInputAssesment.vue?vue&type=template&id=1a9e2f73&scoped=true"
import script from "./VaccineInputAssesment.vue?vue&type=script&lang=js"
export * from "./VaccineInputAssesment.vue?vue&type=script&lang=js"
import style0 from "./VaccineInputAssesment.vue?vue&type=style&index=0&id=1a9e2f73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9e2f73",
  null
  
)

export default component.exports